function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.348 34.371c-.268-.134-.218-.375-.005-.452l.669-.243-3.172-8.715-6.319 2.3a2.31 2.31 0 00-1.38 2.96l1.59 4.372a2.312 2.312 0 002.943 1.388c.924.383 3.302 1.604 5.524 4.683.27.373.755.52 1.189.363l2.94-1.07c.64-.233.881-1.01.492-1.566-1.759-2.51-3.632-3.598-4.47-4.02z",
  fill: "#FFF9E2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.64 15.34l-.948.346s-3.005 7.026-6.903 8.9l.01.025.238.654 2.936 8.068c4.19-1.07 11.008 2.38 11.008 2.38l.95-.345a1.469 1.469 0 00.876-1.882l-6.285-17.269a1.466 1.466 0 00-1.881-.877z",
  fill: "#FFF9E2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.74 20.34c-.4-1.097-1.68-1.067-4.42.42-.762.412-1.25.92-1.017 1.56.233.639.994.805 1.869.628 3.227-.65 3.969-1.51 3.569-2.608zM24.477 11.604c-1.115-.348-1.868.688-2.349 3.77-.134.855-.025 1.552.625 1.754.648.202 1.244-.302 1.633-1.105 1.441-2.96 1.206-4.071.09-4.42zM30.397 14.145c-.933-.703-1.99.02-3.478 2.76-.414.762-.545 1.455-.003 1.863.542.408 1.273.134 1.91-.49 2.353-2.305 2.504-3.43 1.571-4.133zM32.53 33.795c-.631.983-1.873.673-4.223-1.377-.652-.57-1.016-1.173-.65-1.746.367-.573 1.148-.567 1.962-.204 3.008 1.34 3.543 2.343 2.911 3.327zM35.427 28.03c-.263 1.14-1.538 1.264-4.44.122-.806-.317-1.351-.763-1.199-1.425.153-.662.89-.92 1.779-.852 3.283.253 4.123 1.016 3.86 2.155z",
  fill: "#FFF9E2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M43.628 15.981c-1.047.147-1.647.643-2.054 1.215-.547-.439-1.261-.75-2.308-.602-1.682.236-2.777 1.632-2.551 3.248.307 2.186 3.547 4.698 5.556 5.4a.938.938 0 00.85-.119c1.738-1.23 4.16-4.538 3.852-6.723-.225-1.615-1.664-2.656-3.345-2.419zM43.047 29.92c-1.055-.075-1.745.287-2.261.762-.445-.543-1.078-.996-2.133-1.07-1.694-.117-3.056 1.02-3.17 2.647-.155 2.202 2.493 5.333 4.311 6.438a.933.933 0 00.857.06c1.955-.842 5.012-3.575 5.166-5.776.114-1.627-1.077-2.943-2.77-3.061zM36.075 6.272c-1.055.075-1.688.527-2.133 1.069-.516-.476-1.206-.836-2.261-.762-1.694.119-2.884 1.436-2.77 3.063.154 2.201 3.211 4.934 5.165 5.775a.941.941 0 00.857-.06c1.819-1.104 4.465-4.236 4.312-6.437-.113-1.628-1.476-2.766-3.17-2.648z",
  fill: "#FFE000"
});

var SvgLoudspeaker = function SvgLoudspeaker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoudspeaker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loudspeaker.596c00e5.svg";
export { ForwardRef as ReactComponent };